import PhoneInput from '../PhoneInput';
import './index.css';

const hasEnoughDigits = (value) => (value ?? '').replace(/\D/g, '').length >= 9;

const DriverMobileInput = ({
  inputSpecs,
  value,
  onChange,
  error,
  onConfirmRequest,
  isConfirmed,
}) => {
  const showConfirm = Boolean(onConfirmRequest) && hasEnoughDigits(value);

  const rightAddon = showConfirm ? (
    <button
      type="button"
      onClick={isConfirmed ? undefined : onConfirmRequest}
      className={`driver-mobile-confirm-btn${isConfirmed ? ' driver-mobile-confirm-btn--confirmed' : ''}`}
    >
      {isConfirmed ? '✓ Confirmado' : 'Confirmar Número'}
    </button>
  ) : null;

  return (
    <PhoneInput
      inputSpecs={inputSpecs}
      value={value}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      error={error}
      rightAddon={rightAddon}
    />
  );
};

export default DriverMobileInput;
